import React, { Component } from 'react';
import { AppDataContext } from '../../context/Context';
import { Alert, Snackbar, AlertTitle } from '@mui/material';

class AlertWrapper extends Component {
    constructor(props) {
        super(props);

        this.state = {
            message: '',
            type: '',
            status: ''
        };
    }
    componentDidMount() {
        this.unsubscribe = this.context.subscribe(() => {
            const message = this.context.getState().alertError.message;
            const type = this.context.getState().alertError.type;
            const status = this.context.getState().alertError.status;
            this.setState({ message, type, status });
        });
    }

    componentWillUnmount() {
        if (typeof this.unsubscribe === 'function') {
            try {
                this.unsubscribe();
            } catch (e) {
                // no-op
            }
        }
    }

    static contextType = AppDataContext;

    render() {
        const { type, message, status } = this.state;
        const closeSnackbar = () =>
            this.context.update({ alertError: { message: '' } });
        return (
            <>
                {type === 'snackbar' ? (
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right'
                        }}
                        open={!!message}
                        onClose={() => closeSnackbar()}
                    >
                        {message ? (
                            <Alert
                                severity={status}
                                onClose={() => closeSnackbar()}
                            >
                                {message}
                            </Alert>
                        ) : (
                            <div></div>
                        )}
                    </Snackbar>
                ) : type === 'dialog' ? (
                    message ? (
                        <Alert severity={status}>
                            <AlertTitle>Error</AlertTitle>
                            {message}
                        </Alert>
                    ) : (
                        <div></div>
                    )
                ) : null}
            </>
        );
    }
}

export default AlertWrapper;
